import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { parseSummary, parseWallet, summaryParams } from './data';

export default function useAgentEarnings(selection, walletEnabled, navigate) {
    const [revision, setRevision] = useState(0);
    const [earnings, setEarnings] = useState({ loading: true, data: null, error: '' });
    const [wallet, setWallet] = useState({ loading: true, data: null, error: '' });
    const refresh = useCallback(() => setRevision(value => value + 1), []);
    useEffect(() => {
        // Re-fetch at the next interval so KST midnight is evaluated by the server.
        const timer = setInterval(() => { if (!document.hidden) refresh(); }, 60000);
        const visible = () => { if (!document.hidden) refresh(); };
        document.addEventListener('visibilitychange', visible);
        return () => { clearInterval(timer); document.removeEventListener('visibilitychange', visible); };
    }, [refresh]);
    useEffect(() => {
        let active = true;
        const controller = new AbortController();
        setEarnings({ loading: true, data: null, error: '' });
        async function load() {
            try {
                const response = await axios.get(process.env.REACT_APP_API + '/api/agent-dashboard/summary', { params: summaryParams(selection), withCredentials: true, signal: controller.signal, timeout: 15000 });
                if (!active) return;
                if (response.data?.code === 9999) { navigate('/', { replace: true }); return; }
                if (response.data?.code !== 1000) throw new Error(response.data?.msg || '수익 정보를 불러오지 못했습니다.');
                setEarnings({ loading: false, data: parseSummary(response.data.data), error: '' });
            } catch (error) {
                if (!active || controller.signal.aborted) return;
                if (error.response?.data?.code === 9999) { navigate('/', { replace: true }); return; }
                setEarnings({ loading: false, data: null, error: error.response?.status === 404 ? '수익 조회 서비스를 준비 중입니다.' : error.response?.data?.msg || error.message || '수익 정보를 불러오지 못했습니다.' });
            }
        }
        load();
        return () => { active = false; controller.abort(); };
    }, [selection, revision, navigate]);
    useEffect(() => {
        if (!walletEnabled) { setWallet({ loading: false, data: null, error: '' }); return; }
        let active = true;
        const controller = new AbortController();
        setWallet({ loading: true, data: null, error: '' });
        async function load() {
            try {
                const response = await axios.get(process.env.REACT_APP_API + '/api/agent-wallet/balance', { withCredentials: true, signal: controller.signal, timeout: 15000 });
                if (!active) return;
                if (response.data?.code === 9999) { navigate('/', { replace: true }); return; }
                if (response.data?.code !== 1000) throw new Error(response.data?.msg || '지갑 정보를 불러오지 못했습니다.');
                setWallet({ loading: false, data: parseWallet(response.data.data), error: '' });
            } catch (error) {
                if (!active || controller.signal.aborted) return;
                if (error.response?.data?.code === 9999) { navigate('/', { replace: true }); return; }
                setWallet({ loading: false, data: null, error: error.response?.data?.msg || error.message });
            }
        }
        load();
        return () => { active = false; controller.abort(); };
    }, [walletEnabled, revision, navigate]);
    return { earnings, wallet, refresh };
}
